<template>
  <div class="statistics">
    <div class="item" v-for="item in list" :key="item.title">
      <img :src="item.icon" class="content-icon" alt="" />
      <div>
        <div class="value">
          {{ item.value }}
        </div>

        <div class="title">
          {{ item.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  list: {
    type: Array,
    default: () => [],
  },
});
</script>

<style scoped lang="less">
.statistics {
  margin-top: 24px;

  display: grid;

  grid-template-columns: repeat(4, 1fr);

  gap: 24px;

  background: #fff;
  box-shadow: 0px 5px 18px 0px rgba(35, 68, 120, 0.05);
  border-radius: 16px 16px 16px 16px;
  border: 1px solid #dfe6f2;
}

.item {
  border-radius: 16px;

  padding: 30px;

  text-align: center;
  justify-content: center;
  transition: 0.25s;
  display: flex;
}

.item:hover {
  transform: translateY(-4px);

  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
}

.content-icon {
  width: 46px;
  height: 46px;
  margin-right: 12px;
}
.value {
  font-weight: 600;
  font-size: 18px;
  color: #1768ff;
}

.title {
  margin-top: 8px;
  font-weight: 400;
  font-size: 13px;
  color: #64738d;
}

@media (max-width: 900px) {
  .statistics {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .statistics {
    grid-template-columns: 1fr;
  }
}
</style>
